import type { SlipPrintJobModel } from "@lumora/core";
import { ConfirmGate } from "./ConfirmGate.js";

/** Queue "Visit Us" QR slips on the site's kitchen Pi; no SSH (#1139). */
export function SlipPrintForm({
  copiesText,
  title,
  qrUrl,
  submitting,
  error,
  onCopies,
  onTitle,
  onQrUrl,
  onSubmit,
}: {
  copiesText: string;
  title: string;
  qrUrl: string;
  submitting: boolean;
  error: string | null;
  onCopies: (v: string) => void;
  onTitle: (v: string) => void;
  onQrUrl: (v: string) => void;
  onSubmit: () => void;
}) {
  return (
    <form
      className="site-signin"
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <label>
        Copies
        <input
          type="number"
          min={1}
          max={200}
          inputMode="numeric"
          value={copiesText}
          onChange={(e) => onCopies(e.target.value)}
        />
      </label>
      <label>
        Title (optional, defaults to site name)
        <input value={title} maxLength={64} onChange={(e) => onTitle(e.target.value)} />
      </label>
      <label>
        QR link (optional, defaults to the site URL)
        <input type="url" value={qrUrl} placeholder="https://" onChange={(e) => onQrUrl(e.target.value)} />
      </label>
      {error ? <p className="ops-error" role="alert">{error}</p> : null}
      <button type="submit" disabled={submitting}>
        {submitting ? "Queuing…" : "Print QR slips"}
      </button>
      <p className="muted">
        Prints when the kitchen Pi next polls, during kitchen hours. New orders print first.
      </p>
    </form>
  );
}

export function SlipPrintJobsTable({
  jobs,
  onCancel,
}: {
  jobs: SlipPrintJobModel[];
  onCancel: (id: string) => void;
}) {
  if (jobs.length === 0) {
    return <p className="muted">No slip jobs yet.</p>;
  }
  return (
    <div className="ops-table-wrap">
      <table className="ops-table">
        <thead>
          <tr>
            <th>Queued</th>
            <th>Printed</th>
            <th>Status</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {jobs.map((j) => (
            <tr key={j.id}>
              <td>{new Date(j.row.createdAt).toLocaleString()}</td>
              <td>{j.progressLabel()}</td>
              <td>{j.statusLabel()}</td>
              <td>
                {j.isOpen() ? (
                  <ConfirmGate
                    idleLabel="Cancel"
                    confirmLabel="Yes, stop printing"
                    onConfirm={() => onCancel(j.id)}
                  />
                ) : null}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
